(() => {
  document.querySelectorAll('[data-free-wavcheck]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const video = root.querySelector('.wm-free__video video');
    const playButton = root.querySelector('[data-video-play]');
    if (video && playButton) {
      video.controls = false;
      playButton.hidden = false;
      playButton.addEventListener('click', async () => {
        video.controls = true;
        try { await video.play(); }
        catch { playButton.hidden = true; video.focus(); }
      });
      video.addEventListener('play', () => { playButton.hidden = true; });
      video.addEventListener('ended', () => { video.controls = false; playButton.hidden = false; });
    }
    const form = root.querySelector('[data-free-form]');
    const sms = root.querySelector('[data-free-sms]');
    const smsConsent = form.elements.smsConsent;
    const normalizePhone = target => {
      const input = target.elements.phone;
      if (!input) return '';
      let digits = input.value.replace(/\D/g, '');
      if (target.elements.phoneCountry?.value === 'OTHER') {
        const codeInput = target.elements.customCountryCode;
        const code = codeInput.value.trim().replace(/^\+/, '');
        const codeValid = /^[1-9]\d{0,2}$/.test(code);
        codeInput.setCustomValidity(codeValid ? '' : codeInput.dataset.codeError);
        const valid = /^[1-9]\d{3,13}$/.test(digits) && code.length + digits.length <= 15;
        input.setCustomValidity(valid ? '' : input.dataset.internationalError);
        return codeValid && valid ? '+' + code + digits : '';
      }
      if (digits.length === 11 && digits.startsWith('1')) digits = digits.slice(1);
      const valid = /^[2-9]\d{2}[2-9]\d{6}$/.test(digits);
      input.setCustomValidity(valid ? '' : input.dataset.phoneError);
      return valid ? '+1' + digits : '';
    };
    [form, sms].forEach(target => {
      target.elements.phone?.addEventListener('input', () => target.elements.phone.setCustomValidity(''));
      const country = target.elements.phoneCountry;
      const custom = target.elements.customCountryCode;
      const updateCountry = () => {
        if (!country || !custom) return;
        const other = country.value === 'OTHER';
        custom.hidden = !other; custom.disabled = !other; custom.required = other;
        custom.setCustomValidity('');
        target.elements.phone.setCustomValidity('');
        target.elements.phone.placeholder = other ? '' : '(201) 555-0123';
        const consent = target.elements.smsConsent;
        consent.disabled = other;
        if (other) consent.checked = false;
        target.querySelector('[data-sms-consent-label]').hidden = other;
        target.querySelector('[data-international-note]').hidden = !other;
        if (target === sms) target.querySelector('[type=submit]').disabled = other;
      };
      country?.addEventListener('change', updateCountry);
      custom?.addEventListener('input', () => custom.setCustomValidity(''));
      updateCountry();
    });
    const pending = root.querySelector('[data-free-pending]');
    const ready = root.querySelector('[data-free-ready]');
    const status = root.querySelector('[data-free-status]');
    const check = root.querySelector('[data-free-check]');
    const storageKey = 'wm-free-wavcheck-v2';
    let session = null;
    try { session = JSON.parse(sessionStorage.getItem(storageKey)); } catch {}
    const save = () => { try { sessionStorage.setItem(storageKey, JSON.stringify(session)); } catch {} };
    const message = (text, error = false) => { status.textContent = text; status.dataset.error = String(error); };
    const request = async body => {
      if (!root.dataset.worker) throw Error(root.dataset.error);
      const response = await fetch(root.dataset.worker.replace(/\/$/, '') + '/free-plugin/wavcheck', {
        method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify(body), signal: AbortSignal.timeout(20000)
      });
      const data = await response.json();
      if (!response.ok || data.freePlugin !== true) throw Error(data.message || root.dataset.error);
      return data;
    };
    const showPending = () => { form.hidden = true; sms.hidden = true; pending.hidden = false; pending.querySelector('h2').focus(); };
    const poll = async () => {
      if (check.disabled || !session?.claim) return;
      check.disabled = true;
      message(root.dataset.working);
      try {
        const data = await request({ action: 'status', ...session });
        if (data.status === 'ready') {
          pending.hidden = true;
          ready.hidden = false;
          message('');
          ready.querySelector('h2').focus();
        } else message(root.dataset.pending);
      } catch (error) { message(error.message || root.dataset.error, true); }
      finally { check.disabled = false; }
    };
    check.addEventListener('click', poll);
    root.querySelector('[data-free-skip]').addEventListener('click', () => { session.smsDone = true; save(); showPending(); poll(); });
    sms.addEventListener('submit', async event => {
      event.preventDefault();
      const phone = normalizePhone(sms);
      if (!sms.reportValidity()) return;
      const button = sms.querySelector('[type=submit]');
      if (button.disabled) return;
      button.disabled = true;
      try {
        await request({ action: 'sms', claim: session.claim, token: session.token, phone, smsConsent: sms.elements.smsConsent.checked, consentVersion: root.dataset.consentVersion });
        session.smsDone = true; save(); showPending(); await poll();
      } catch (error) { message(error.message || root.dataset.error, true); }
      finally { button.disabled = false; }
    });
    form.addEventListener('submit', async event => {
      event.preventDefault();
      const phone = normalizePhone(form);
      if (!form.reportValidity()) return;
      const button = form.querySelector('button');
      if (button.disabled) return;
      button.disabled = true;
      message(root.dataset.working);
      if (!session) { session = { token: crypto.randomUUID() }; save(); }
      try {
        const data = await request({ action: 'begin', token: session.token, first_name: form.elements.first_name.value, email: form.elements.email.value,
          emailConsent: form.elements.emailConsent.checked,
          consentVersion: root.dataset.consentVersion, company: form.elements.company.value });
        session = { claim: data.claim, token: data.token }; save();
        if (root.dataset.smsEnabled === 'true' && smsConsent?.checked && !smsConsent.disabled) {
          try {
            await request({ action: 'sms', claim: session.claim, token: session.token, phone, smsConsent: true, consentVersion: root.dataset.consentVersion });
          } catch (error) {
            message(error.message || root.dataset.error, true);
            form.elements.phone.focus();
            return;
          }
        }
        session.smsDone = true; save(); showPending(); await poll();
      } catch (error) { message(error.message || root.dataset.error, true); }
      finally { button.disabled = false; }
    });
    if (session?.claim) {
      if (session.smsDone || root.dataset.smsEnabled !== 'true') { showPending(); poll(); }
      else { form.hidden = false; sms.hidden = true; }
    }
  });
})();
